<p-toolbar styleClass="">
  <ng-template pTemplate="left">
  </ng-template>

  <ng-template pTemplate="right">
    <p-button icon="pi pi-refresh" label="Обновить" styleClass="p-button-success mr-2" (onClick)="reloadTable($event)"
              pTooltip="Обновить таблицу документов" tooltipPosition="top"></p-button>

    <p-button icon="pi pi-undo" label="Сбросить фильтр" styleClass="p-button-success mr-2" (onClick)="clearOrResetTableFilter($event)"
              pTooltip="Сбросить фильтр и вернуться в начало" tooltipPosition="top"></p-button>

    <p-button label="XLSX" icon="pi pi-file-excel" styleClass="p-button-info mr-2" (onClick)="onExportData()"
              pTooltip="Экспортировать список документов" tooltipPosition="top" [disabled]="!totalNotPaidOrders"></p-button>
  </ng-template>
</p-toolbar>

<p-table #ptable5 [value]="notPaidOrdersList"
         [rows]="10"
         [rowsPerPageOptions]="[10,25,50]"
         [loading]="loading"
         [showCurrentPageReport]="true"
         [totalRecords]="totalNotPaidOrders"
         [paginator]="true"
         currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} документов"
         sortMode="single"
         sortField="unpaidDays"
         [sortOrder]="-1"
         dataKey="DOCID"
         selectionMode="single"
         [(selection)]="notPaidSelectedDocument"
         [resizableColumns]="true"
         (onRowSelect)="onPaidRowSelect($event)"
         [rowHover]="true"
         rowExpandMode="single"
         (onFilter)="onFilterEvent($event)"
         stateStorage="local"
         stateKey="dashboardOrders4-state"
         (onStateSave)="onStateSave($event)"
         (onStateRestore)="onStateRestoreNotPaid($event)"
         styleClass="p-datatable-gridlines p-datatable-striped">

  <ng-template pTemplate="caption">
    <div class="grid align-items-center">
      <div class="col-2">
        <h5>Счета за {{monthToLoad}} месяцев: </h5>
      </div>
      <div class="col-2">
        <p-slider [(ngModel)]="monthToLoad" [min]="monthToLoadMin" [max]="monthToLoadMax" [step]="6" (onSlideEnd)="onSlideEnd($event)"></p-slider>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th pResizableColumn style="width: 3rem !important">...</th>
      <th pResizableColumn pSortableColumn="DOCNUMBER" style="width: 8rem !important">Номер <p-sortIcon field="DOCNUMBER"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCDATE" style="width: 8rem !important">Дата <p-sortIcon field="DOCDATE"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="LOCALCOMP" style="width: 10rem !important">Продавец <p-sortIcon field="LOCALCOMP"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="AUTHOR" style="width: 9rem !important">Автор <p-sortIcon field="AUTHOR"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="PARTNERNAMESTR" style="width: auto !important">Заказчик <p-sortIcon field="PARTNERNAMESTR"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCSUM" style="width: 8rem !important">Сумма <p-sortIcon field="DOCSUM"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="PAYDSUM" style="width: 8rem !important">Оплачено <p-sortIcon field="PAYDSUM"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="SHIPSUM" style="width: 8rem !important">Отгружено <p-sortIcon field="SHIPSUM"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="SHIPFIRSTDATE" style="width: 8rem !important">Дата отгрузки <p-sortIcon field="SHIPFIRSTDATE"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="unpaidDays" style="width: 8rem !important">Просрочка <p-sortIcon field="unpaidDays"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCNOTE1" style="max-width: 150px !important; width: 10% !important">Пр. продавца <p-sortIcon field="DOCNOTE1"></p-sortIcon></th>
      <th pResizableColumn pSortableColumn="DOCNOTE2" style="max-width: 150px !important; width: 10% !important">Пр. покупателя <p-sortIcon field="DOCNOTE2"></p-sortIcon></th>
    </tr>
    <tr>
      <th pResizableColumn style="width: 3rem">...</th>
      <th pResizableColumn><input pInputText [(ngModel)]="cf['DOCNUMBER']" [class.hasvalue]="cf['DOCNUMBER']" type="text" (input)="ptable5.filter($event.target.value, 'DOCNUMBER', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText [(ngModel)]="cf['DOCDATE']" [class.hasvalue]="cf['DOCDATE']" type="text" (input)="ptable5.filter($event.target.value, 'DOCDATE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText [(ngModel)]="cf['LOCALCOMP']" [class.hasvalue]="cf['LOCALCOMP']" type="text" (input)="ptable5.filter($event.target.value, 'LOCALCOMP', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText [(ngModel)]="cf['AUTHOR']" [class.hasvalue]="cf['AUTHOR']" type="text" (input)="ptable5.filter($event.target.value, 'AUTHOR', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText [(ngModel)]="cf['PARTNERNAMESTR']" [class.hasvalue]="cf['PARTNERNAMESTR']" type="text" (input)="ptable5.filter($event.target.value, 'PARTNERNAMESTR', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText [(ngModel)]="cf['DOCSUM']" [class.hasvalue]="cf['DOCSUM']" type="text" (input)="ptable5.filter($event.target.value, 'DOCSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText [(ngModel)]="cf['PAYDSUM']" [class.hasvalue]="cf['PAYDSUM']" type="text" (input)="ptable5.filter($event.target.value, 'PAYDSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText [(ngModel)]="cf['SHIPSUM']" [class.hasvalue]="cf['SHIPSUM']" type="text" (input)="ptable5.filter($event.target.value, 'SHIPSUM', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText [(ngModel)]="cf['SHIPFIRSTDATE']" [class.hasvalue]="cf['SHIPFIRSTDATE']" type="text" (input)="ptable5.filter($event.target.value, 'SHIPFIRSTDATE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText [(ngModel)]="cf['unpaidDays']" [class.hasvalue]="cf['unpaidDays']" type="text" (input)="ptable5.filter($event.target.value, 'unpaidDays', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText [(ngModel)]="cf['DOCNOTE1']" [class.hasvalue]="cf['DOCNOTE1']" type="text" (input)="ptable5.filter($event.target.value, 'DOCNOTE1', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
      <th pResizableColumn><input pInputText [(ngModel)]="cf['DOCNOTE2']" [class.hasvalue]="cf['DOCNOTE2']" type="text" (input)="ptable5.filter($event.target.value, 'DOCNOTE2', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-npol let-expanded="expanded">

    <tr [pSelectableRow]="npol" class="docid_{{npol.DOCID}}"
        [class.futuredocs]="npol.fd"
        [class.grayout]="npol.go"
        [class.partiallypaiddoc]="npol.pp"
        [class.fullypaiddoc]="npol.fp"
        [class.todaydocuments]="npol.td"
        [class.proformadoc]="(npol.DOCTYPEID == 12)"
        [class.inorderdoc]="(npol.DOCTYPEID == 2)"
        [class.banktransferdoc]="(npol.DOCTYPEID == 9)"
        [class.purchorderdoc]="(npol.DOCTYPEID == 10)"
        [class.yellowdoc]="(npol.DOCTYPEID == 14)"
        [class.specdoc]="(npol.DOCTYPEID == 7)"
        [class.shiporderdoc]="(npol.DOCTYPEID == 4)"
        [class.invoicedoc]="(npol.DOCTYPEID == 1)">
      <td style="max-width: 5rem !important; padding:0.75rem !important;">
        <button type="button" pButton pRipple [pRowToggler]="npol"
                class="p-button-text p-button-rounded p-button-plain"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
      </td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><a [routerLink]="['/edit-document', npol.DOCTYPEID, npol.DOCID]">{{npol.DOCNUMBER}}</a></td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{npol.DOCDATE  | date:'dd.MM.yyyy'}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{npol.LOCALCOMP}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{npol.AUTHOR}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><a [routerLink]="['/edit-client', npol.DOCCLIENTSID]">{{npol.PARTNERNAMESTR}}</a></td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{npol.DOCSUM | number:'1.2-2' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{npol.PAYDSUM | number:'1.2-2' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{npol.SHIPSUM | number:'1.2-2' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{npol.SHIPFIRSTDATE  | date:'dd.MM.yyyy'}}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{npol.unpaidDays | number:'1.0-0' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><input pInputText type="text" [(ngModel)]="npol.DOCNOTE1" [style]="{'width':'100%'}" readonly alt="{{npol.DOCNOTE1}}"></td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><input pInputText type="text" [(ngModel)]="npol.DOCNOTE2" [style]="{'width':'100%'}" readonly alt="{{npol.DOCNOTE2}}"></td>
    </tr>
  </ng-template>

  <ng-template pTemplate="rowexpansion" let-npol>
    <tr>
      <td colspan="13">
        <div class="p-p-2">
          <app-document-content-table [selectedDocumentId]="npol.DOCID" [showFooterTotal]="true"></app-document-content-table>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="footer">
    <tr>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{totalInvoiceSum | number:'1.2-2' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{totalPaidSum | number:'1.2-2' }}</td>
      <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{totalShippedSum | number:'1.2-2' }}</td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="13">На сегодня просроченных счетов нет</td>
    </tr>
  </ng-template>
</p-table>
